import React from 'react';
import Tabs from '../Tabs';
import Form from '../Form';

export default () => (
  <Tabs defaultIndex={0}>
    <Tabs.Tab label="Become a Partner">
      <h2>
        Ready to get started? Provide your details to receive further information and schedule a 1:1
        meeting with our Partner Success team.
      </h2>
      <Form title="Become a Partner" />
    </Tabs.Tab>
    <Tabs.Tab label="Find a Partner">
      <h2>
        Need to solve a sophisticated identity challenge? Our network of partners extends around the
        globe. Partners offer experise from security consulting and systems integration to
        implementation and application development.
      </h2>
      <Form title="Find a Partner" />
    </Tabs.Tab>
  </Tabs>
);



// WEBPACK FOOTER //
// ./src/pages/partners/components/App/index.js